import(/* webpackMode: "eager", webpackExports: ["TooltipArrow"] */ "/var/www/ouinex.com/frontend/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.js\",\"import\":\"Poppins\",\"arguments\":[{\"display\":\"swap\",\"weight\":[\"300\",\"400\",\"500\",\"700\",\"800\"],\"subsets\":[\"latin\"],\"variable\":\"--font-poppins\"}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/assets/styles/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/globals/CookiePreferences/CookiePreferences.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/globals/Header/HeaderDataProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/globals/Header/NavigationMenu.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/globals/Newsletter.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/GoogleAnalytics/LazyGoogleAnalytics.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/HSForms/LazyHSForms.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/LanguageSwitcher/LanguageSwitcher.js");
;
import(/* webpackMode: "eager" */ "/var/www/ouinex.com/frontend/src/components/NavigationLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ouinex.com/frontend/src/components/SuggestedLanguageAlert.js");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/var/www/ouinex.com/frontend/src/components/ui/accordion.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/var/www/ouinex.com/frontend/src/components/ui/separator.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider","Tooltip","TooltipTrigger","TooltipContent"] */ "/var/www/ouinex.com/frontend/src/components/ui/tooltip.jsx");
